export default {
  data() {
    return {
      // There are cases that is overwritten by component
      // Eg: Multi choice image question allows key press to reset a previously selected choice
      // Eg: Radio questions do not!
      resetSelectedThroughKeyPress: false,
    };
  },
  computed: {
    shouldShowKeyboardHint() {
      return this.options.length <= 26;
    },
  },
  methods: {
    handleKeydownEvent(event) {
      if (!this.shouldShowKeyboardHint) return;

      if (!event.code.startsWith('Key')) return;

      const normalisedKey = event.code.replace('Key', '').toLowerCase();

      const keyIndex = this.getIndexFromKey(normalisedKey);

      const option = this.options[keyIndex];

      if (option !== undefined) {
        if (this.fieldValue === option.id && this.resetSelectedThroughKeyPress) {
          this.resetSelection();
          return;
        }
        this.fakeClickOnInput(option.id);
        document.querySelector(`#${this.generateSafeId(this.fieldQuestionId, option.id, 'label')}`).focus();
      }
    },
    fakeClickOnInput(optionId) {
      const target = this.generateSafeId(this.fieldQuestionId, optionId, 'ref');
      this.$refs[target][0].click();
    },
  },
};
